import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import type { TagSortDirection, TagSortField } from "./tagUtils";

interface TagsTableHeaderProps {
  sortField: TagSortField;
  sortDirection: TagSortDirection;
  onSort: (field: TagSortField) => void;
}

function SortIcon({
  field,
  currentField,
  direction,
}: {
  field: TagSortField;
  currentField: TagSortField;
  direction: TagSortDirection;
}) {
  if (currentField !== field) {
    return <ArrowUpDown className="ml-1 h-4 w-4 text-ink-400" />;
  }
  return direction === "asc" ? (
    <ArrowUp className="ml-1 h-4 w-4 text-ink-600" />
  ) : (
    <ArrowDown className="ml-1 h-4 w-4 text-ink-600" />
  );
}

export function TagsTableHeader({
  sortField,
  sortDirection,
  onSort,
}: TagsTableHeaderProps) {
  return (
    <thead>
      <tr className="border-b border-grid-200 bg-grid-50">
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("name")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Tag name
            <SortIcon
              field="name"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          Color
        </th>
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("filesCount")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Files
            <SortIcon
              field="filesCount"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-left">
          <button
            onClick={() => onSort("isActive")}
            className="flex items-center text-xs font-semibold uppercase tracking-wider text-ink-600 hover:text-ink-900"
          >
            Active
            <SortIcon
              field="isActive"
              currentField={sortField}
              direction={sortDirection}
            />
          </button>
        </th>
        <th className="px-6 py-4 text-right text-xs font-semibold uppercase tracking-wider text-ink-600">
          Actions
        </th>
      </tr>
    </thead>
  );
}
